<fragment>
  <div
    v-if="getAttribute('showPreflight')"
    v-bind:class="useClassName"
  >
    <appPreflightInfo
      v-for="(item,index) in preflightData"
      v-bind:key="index"
      v-bind:propsData="item"
    >
    </appPreflightInfo>
  </div>
  <div
    v-if="showPitstopInfo || showPitstopLoading"
    v-bind:class="useClassName"
  >
    <appPreflightInfo
      v-if="showPitstopInfo"
      v-for="(item,index) in showPitstopInfo"
      v-bind:key="index"
      v-bind:propsData="item"
    >
    </appPreflightInfo>
    <div v-if="showPitstopLoading">
      <appUploadLoading></appUploadLoading>
    </div>
  </div>
</fragment>